import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Pricing } from './pages/Pricing';
import { useHashRoute } from './hooks/useHashRoute';
export function App() {
  const route = useHashRoute();
  return <div className="min-h-screen w-full bg-white font-sans text-gray-900 selection:bg-red-200 selection:text-red-900" data-id="element-0" data-mp="3f8ezxm85fxv9">
      <AnnouncementBar data-id="element-1" data-mp="2mlu9qp3etrta" />
      <Navbar route={route} data-id="element-2" data-mp="2mmcb204xiw82" />
      <main data-id="element-3" data-mp="2mn5f2tci77mi">{route === 'pricing' ? <Pricing data-id="element-4" data-mp="2mjpy1kz9roig" /> : <Home data-id="element-5" data-mp="31aqdi9yfoio3" />}</main>
      <Footer data-id="element-6" data-mp="31b8ko1mmwhas" />
    </div>;
}